// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Wo74","content":"styles_content__31H8T"};